import styled from 'styled-components'
import breakpoints from './breakpoints'

const Mobile = styled.div`
display: block;
${breakpoints.md} {
  display: none;
}
`
export default Mobile